export function setItemInLocalStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function getItemFromLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function removeItemFromLocalStorage(key) {
  localStorage.removeItem(key);
}
